<template>
  <main class="flex max-h-svh h-full overflow-hidden pt-20">
    <aside id="side-nav" class="bg-gray-100">
      <nav
        v-if="!excludeNav"
        class="w-64 px-2 py-4 h-full flex flex-col justify-between gap-2"
      >
        <div class="space-y-2">
          <NavItem
            v-for="route in routes"
            :key="route.name"
            :id="formatId(route.name)"
            :to="{
              name: route.name,
              params: { vendor: currentRoute.params.vendor },
            }"
            :name="route.name"
            :icon="route.meta.icon"
            :is-admin="route.meta.isAdmin"
          />
          <slot name="nav-routes"></slot>
        </div>

        <div class="border-t border-gray-300 pt-4 px-2 flex justify-between">
          <button class="flex gap-2" @click="startTour">
            <MapIcon class="w-4" />Take Tour
          </button>
        </div>
      </nav>
    </aside>

    <div class="w-full overflow-y-auto flex flex-col justify-between gap-20">
      <slot name="content"></slot>
      <Footer />
    </div>
  </main>
</template>

<script setup>
import { useCookies } from "@vueuse/integrations/useCookies";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import Footer from "@/components/Footer.vue";
import MapIcon from "@/components/icons/Map.vue";
import NavItem from "@/components/NavItem.vue";
import useOnboardingStore from "@/stores/onboarding";
import useUserStore from "@/stores/user";

const onboardingStore = useOnboardingStore();
const userStore = useUserStore();
const { user, vendorKey } = storeToRefs(userStore);

const currentRoute = useRoute();
const router = useRouter();
const { remove } = useCookies();

const props = defineProps({
  excludeNav: { type: Boolean, default: false },
});

const routes = computed(() => {
  return router
    .getRoutes()
    .filter((route) => {
      const isAuthorizedAdmin =
        route.meta?.isAdmin &&
        user.value?.permissions?.includes(route.meta?.permission);
      return route.meta?.navGroup === "home" || isAuthorizedAdmin;
    })
    .sort((a, b) => a.meta.navOrder - b.meta.navOrder);
});

function formatId(name) {
  const kebabName = name.replace(/\s+/g, "-").toLowerCase();
  return `nav-item-${kebabName}`;
}

function startTour() {
  remove("dashboard-onboarding-completed", { path: "/" });
  remove("search-onboarding-completed", { path: "/" });
  remove("domain-onboarding-completed", { path: "/" });
  remove("editor-onboarding-completed", { path: "/" });
  router.push({ name: "Dashboard" });
  onboardingStore.start();
}
</script>
